import React from 'react'
import betStepperMinusImage from '@assets/button-betstepper-enabled-minus.svg'
import betStepperPlusImage from '@assets/button-betstepper-enabled-plus.svg'
import betStepperMinusImageEQ from '@assets/jackpot-eq/button-betstepper-enabled-minus.svg'
import betStepperPlusImageEQ from '@assets/jackpot-eq/button-betstepper-enabled-plus.svg'
import { useJackpotStore } from '@stores'
import { cn } from '@amusnet/react-ui'

type Props = {
    type: 'plus' | 'minus'
    disabled?: boolean
    onClick?: () => void
    className?: string
}

const BetStepperButton: React.FC<Props> = ({ type, disabled, onClick, className }) => {
    const isEQJackpotType = useJackpotStore((state) => state.isEQJackpotType)

    const betStepperPlus = !isEQJackpotType ? betStepperPlusImage : betStepperPlusImageEQ
    const betStepperMinus = !isEQJackpotType ? betStepperMinusImage : betStepperMinusImageEQ

    const imageSrc = type === 'plus' ? betStepperPlus : betStepperMinus

    return (
        <img
            src={imageSrc}
            alt={`bet-stepper-${type}`}
            onClick={!disabled ? onClick : undefined}
            className={cn(
                'transition-transform duration-100 active:scale-95 touch-manipulation',
                disabled ? 'opacity-50 pointer-events-none' : 'cursor-pointer pointer-events-auto',
                className
            )}
        />
    )
}

export default BetStepperButton
